import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

export default function BlogPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/blog/${id}`).then((r) => setPost(r.data)).catch(() => setPost(null)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="pt-40 text-center text-bark">Loading…</div>;
  if (!post) return <div className="pt-40 text-center text-bark" data-testid="blog-not-found">Article not found.</div>;

  return (
    <article className="pt-28 md:pt-36 pb-24" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <Link to="/learn" className="text-bark hover:text-terracotta text-sm mb-6 inline-block">← Back to journal</Link>
        <div className="flex gap-2 mb-4">
          {(post.tags || []).map((t) => (
            <span key={t} className="overline text-moss">{t}</span>
          ))}
        </div>
        <h1 className="font-serif text-4xl md:text-6xl text-espresso tracking-tight leading-tight mb-8">{post.title}</h1>
        <div className="overflow-hidden rounded-2xl aspect-[16/9] bg-sand mb-10">
          <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
        </div>
        <div className="prose max-w-none text-espresso/90 leading-relaxed text-lg whitespace-pre-line">
          {post.body}
        </div>
      </div>
    </article>
  );
}
